import React from 'react';
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';

import ReportQuickFiltersSettings from './ReportQuickFiltersSettings';

const ReportQuickFiltersModal = ({
  isOpen,
  close,
}: {
  isOpen: boolean;
  close: () => void;
}) => (
  <ModalTransition>
    {isOpen && (
      <ModalDialog
        onClose={close}
        shouldScrollInViewport={false}
        autoFocus={false}
      >
        <ReportQuickFiltersSettings close={close} />
      </ModalDialog>
    )}
  </ModalTransition>
);

export default ReportQuickFiltersModal;
